import { render, staticRenderFns } from "./Candidate-datas.vue?vue&type=template&id=90863a10&scoped=true&"
import script from "./Candidate-datas.vue?vue&type=script&lang=js&"
export * from "./Candidate-datas.vue?vue&type=script&lang=js&"
import style0 from "./assets/data.less?vue&type=style&index=0&id=90863a10&scoped=true&lang=less&"
import style1 from "./Candidate-datas.vue?vue&type=style&index=1&id=90863a10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90863a10",
  null
  
)

export default component.exports